import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to #hash anchor smoothly after route/hash change.
 * Retries up to 30 times (~1.5s) to handle async-rendered sections.
 * Falls back to scroll-to-top when there's no hash.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      // Scroll to top on plain navigation (but NOT for in-app routes which manage their own scroll)
      if (!pathname.startsWith("/app") && !pathname.startsWith("/admin")) {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }
      return;
    }

    const id = hash.slice(1);
    let attempts = 0;
    let timeoutId;

    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (el) {
        // Use small offset for sticky header (around 80px)
        const top = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: "smooth" });
        return true;
      }
      return false;
    };

    const tryScroll = () => {
      if (scrollToTarget()) return;
      attempts += 1;
      if (attempts < 30) {
        timeoutId = setTimeout(tryScroll, 50);
      }
    };

    tryScroll();
    return () => clearTimeout(timeoutId);
  }, [pathname, hash]);

  return null;
}
